module.exports = __webpack_public_path__ + "07bce743d0a01f102bb6c1235f4a2fc4.svg";